import { CSVImportUIColumn, CellError } from "./CSVImportUI";
import { validateDateStr } from "./validateDateStr";

export const standardValidator = (
  column: CSVImportUIColumn,
  value: string,
): CellError | undefined => {
  if (column.required) {
    if (!value) {
      return [column.label, `この項目は必須です`];
    }
  }
  if (column.type === "number") {
    if (value && isNaN(Number(value))) {
      return [column.label, `数値で入力してください`];
    }
  }
  if (column.type === "date") {
    if (value && !validateDateStr(value)) {
      return [
        column.label,
        `日付の形式が不正です。YYYY-MM-DDのような形式で入力してください。`,
      ];
    }
  }
  if (column.options) {
    if (value && !column.options.includes(value)) {
      return [
        column.label,
        column.options.length < 5
          ? `この項目は${column.options.join(
              ",",
            )}のいずれかを入力してください。`
          : `選択肢から選択してください。`,
      ];
    }
  }
  return undefined;
};
